import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageSquareIcon, UserIcon, ThumbsUpIcon, MessageCircleIcon, SearchIcon, PlusIcon } from 'lucide-react';
import { Sitemap } from '../components/Sitemap';
const FORUM_TOPICS = [{
  title: {
    en: 'Tips for improving English pronunciation',
    ar: 'نصائح لتحسين نطق اللغة الإنجليزية'
  },
  author: 'Sarah Ahmed',
  date: '2 hours ago',
  likes: 24,
  replies: 12,
  tags: ['Pronunciation', 'Speaking']
}, {
  title: {
    en: 'How to remember irregular verbs?',
    ar: 'كيف تتذكر الأفعال غير المنتظمة؟'
  },
  author: 'Mohammed Ali',
  date: '5 hours ago',
  likes: 18,
  replies: 8,
  tags: ['Grammar', 'Study Tips']
}];
export function DiscussionForum() {
  const {
    isArabic
  } = useLanguage();
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-2732">
      <Sitemap currentPage={{
      en: 'Discussion Forum',
      ar: 'منتدى النقاش'
    }} breadcrumbs={[{
      label: {
        en: 'Community',
        ar: 'المجتمع'
      },
      href: '/community'
    }]} data-id="element-2733" />
      <div className="max-w-7xl mx-auto" data-id="element-2734">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-2735">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2736">
            {isArabic ? 'منتدى النقاش' : 'Discussion Forum'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-2737">
            {isArabic ? 'تواصل مع متعلمين آخرين وشارك تجربتك في تعلم اللغة الإنجليزية' : 'Connect with other learners and share your English learning experience'}
          </p>
        </div>
        {/* Search and Create Post */}
        <div className="flex flex-col md:flex-row gap-4 mb-8" data-id="element-2738">
          <div className="flex-1 relative" data-id="element-2739">
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-2740" />
            <input type="text" placeholder={isArabic ? 'ابحث في المنتدى...' : 'Search discussions...'} className="w-full pl-12 pr-4 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} data-id="element-2741" />
          </div>
          <button className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors" data-id="element-2742">
            <PlusIcon className="w-5 h-5" data-id="element-2743" />
            <span data-id="element-2744">{isArabic ? 'موضوع جديد' : 'New Discussion'}</span>
          </button>
        </div>
        {/* Topics List */}
        <div className="space-y-6" data-id="element-2745">
          {FORUM_TOPICS.map((topic, index) => <div key={index} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 p-6" data-id="element-2746">
              <div className="flex items-start justify-between" data-id="element-2747">
                <div className="space-y-4" data-id="element-2748">
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-2749">
                    {isArabic ? topic.title.ar : topic.title.en}
                  </h2>
                  <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400" data-id="element-2750">
                    <div className="flex items-center gap-2" data-id="element-2751">
                      <UserIcon className="w-4 h-4" data-id="element-2752" />
                      <span data-id="element-2753">{topic.author}</span>
                    </div>
                    <span data-id="element-2754">{topic.date}</span>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-2755">
                    {topic.tags.map((tag, i) => <span key={i} className="px-3 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-sm" data-id="element-2756">
                        {tag}
                      </span>)}
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-2757">
                  <button className="flex items-center gap-2 text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400" data-id="element-2758">
                    <ThumbsUpIcon className="w-5 h-5" data-id="element-2759" />
                    <span data-id="element-2760">{topic.likes}</span>
                  </button>
                  <button className="flex items-center gap-2 text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400" data-id="element-2761">
                    <MessageCircleIcon className="w-5 h-5" data-id="element-2762" />
                    <span data-id="element-2763">{topic.replies}</span>
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}